import { colors1, colors2 } from './colorsGradient'

const sourceIndexMap = {
  jeem1: 0,
  moiat: 1,
  saber: 2,
  sfda: 3,
  sls: 4,
}

export function getColorArray(colors, source) {
  const index = sourceIndexMap[source]
  return colors[index] || colors[colors.length - 1]
}

export { colors1, colors2 }
